export const quoteHeadingFromMetaTitle = (title: string | undefined | null): string => {
  if (!title?.trim()) {
    return '';
  }
  return title.replace(/\s*\|\s*Benzinga\s*$/, '').trim();
};
